@if (size() === "large") {
  <div class="radio--container">
    <legend class="radio-label">{{ field().label }}</legend>
    @if (field().required) {
      <span class="required" aria-required="true"></span>
    }
    <div class="radio-options-container">
      @for (option of field().options; track option.key; let i = $index) {
        <label
          [for]="option.key"
          class="subtitle1"
          [formGroup]="parentForm()"
          [class.last]="i === field().options.length - 1"
          [class.disabled]="parentForm().controls[field().key].disabled"
        >
          <input
            type="radio"
            [id]="option.key"
            [attr.name]="field().key"
            [formControlName]="field().key"
            [value]="option.key"
            [attr.checked]="option.key === (currentValue()?.toString()) ? '' : null"
            class="body1"
            (change)="updateValue($event)"
          />
          {{ option.value }}
        </label>
      }
    </div>
  </div>
} @else if (size() === "small") {
  <div class="small-radio--container">
    <span class="body1">{{ field().label }}</span>
    @if (field().required) {
      <span class="required" aria-required="true"></span>
    }
    <div class="radio-options-container">
      @for (option of field().options; track option.key; let i = $index) {
        <label
          [for]="option.key"
          class="subtitle1"
          [formGroup]="parentForm()"
          [class.last]="i === field().options.length - 1"
          [class.disabled]="parentForm().controls[field().key].disabled"
        >
          <input
            type="radio"
            [id]="option.key"
            [attr.name]="field().key"
            [formControlName]="field().key"
            [value]="option.key"
            [attr.checked]="option.key === (currentValue()?.toString()) ? '' : null"
            class="body1"
            (change)="updateValue($event)"
          />
          {{ option.value }}
        </label>
      }
    </div>
  </div>
}
